module.exports = __webpack_public_path__ + "media/images/czechia-flag-round-815124ef2c445e8d1dda69f8a1a9084e.png";